// extracted by mini-css-extract-plugin
module.exports = {"comment_input_div":"styles_comment_input_div__2d79v","input_field":"styles_input_field__3LOqv"};